export default __webpack_public_path__ + "static/img/blowing-rock-pluc.4d23485.jpg";